import { useSeoMeta } from "@unhead/react";
import { Suspense } from "react";
import QuantumScene from "@/components/scenes/QuantumScene";
import { ProjectNavigation } from "@/components/site/ProjectNavigation";

const QuantumLeapPage = () => {
  useSeoMeta({
    title: "Let's FCK!",
    description: "",
  });

  return (
    <div>
      <div className="relative h-screen">
        <Suspense fallback={null}>
          <QuantumScene />
        </Suspense>
      </div>
      <ProjectNavigation href="/portfolio/project-cyberscape" />
    </div>
  );
};

export default QuantumLeapPage;
